module.exports = __webpack_public_path__ + "img/au_4.6f4d8a58.webp";